import styled from "styled-components";

export const HeroSection = styled.section`
  position: relative;
  width: 100%;
  overflow: hidden;
  background-color: ${({ theme }) => theme.background};
  box-shadow: inset 0 0 0 1000px rgba (0, 0, 0, 0.2);
  transition: background-color 0.3s ease-in;

  @media screen and (max-width: 1200px) {
    width: 100%;
    padding-top: 50px;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
`;
